export function scrollTo(elem, offset = 0, returnPromise) {
  const tBody = document.documentElement.getBoundingClientRect().top;
  const tE = elem.getBoundingClientRect().top;
  const t = tE - tBody + offset;
  window.scrollTo({ top: t, behavior: 'smooth' });
  return returnPromise ? new Promise((resolve, reject) => {
    const failed = setTimeout(() => {
      reject();
    }, 2000);

    const scrollHandler = () => {
      if (window.pageYOffset === t) {
        window.removeEventListener('scroll', scrollHandler);
        clearTimeout(failed);
        resolve();
      }
    };
    if (window.pageYOffset === t) {
      clearTimeout(failed);
      resolve();
    } else {
      window.addEventListener('scroll', scrollHandler);
    }
  }) : true;
}

export function deepcopy(x) {
  return JSON.parse(JSON.stringify(x));
}
